import Dropdown from '@cp/src/components/Dropdown';
import { BorderedInput, Button, Typography } from '@navi/web-ui/lib/primitives';
import Drawer from '@navi/web-ui/lib/primitives/Drawer/Drawer';
import styles from './timelines.module.scss';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createTimeline, getTimelinesByTenant } from '../paramountActions';
import { Controller, useForm } from 'react-hook-form';
import cx from 'classnames';
import RequiredIcon from '@icons/RequiredIcon';
import { GenericObject } from '@cp/src/types/CommonConstans';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';

const anchorDateOptions = [{ label: 'FIRST UNPAID DUE DATE', value: 'FIRST_UNPAID_DUE_DATE' }];

const CreateTimelineDrawer = (props: {
  showUploadDrawer: boolean;
  setShowUploadDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { showUploadDrawer, setShowUploadDrawer } = props;
  const dispatch = useDispatch();

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors }
  } = useForm();

  const tenant = useGetTenant();

  const successCb = () => {
    setShowUploadDrawer(false);
    dispatch(getTimelinesByTenant(tenant));
    reset();
  };

  const handleCreateTimeline = (data: GenericObject) => {
    const { timelineName, timelineDescription, productCodes, anchorDate } = data;
    const transformedProductCodes = productCodes.split(',').map((code: string) => code.trim());
    setShowUploadDrawer(false);
    dispatch(
      createTimeline(
        {
          name: timelineName,
          description: timelineDescription,
          productCodes: transformedProductCodes,
          anchorDate: 'FIRST_UNPAID_DUE_DATE'
        },
        tenant,
        successCb
      )
    );
  };

  return (
    <Drawer
      headerText="Create Timeline"
      open={showUploadDrawer}
      showHeaderDivider={true}
      footer={
        <div className="flex justify-center">
          <Button
            variant="primary"
            size="medium"
            onClick={handleSubmit(handleCreateTimeline)}
            className="w-[50%]"
          >
            Create Timeline
          </Button>
        </div>
      }
      onClose={() => {
        setShowUploadDrawer(false);
      }}
      disableOutsideClick={false}
    >
      <form onSubmit={handleSubmit(handleCreateTimeline)}>
        <Controller
          control={control}
          name={'timelineName'}
          rules={{ required: true }}
          render={({ field: { onChange, value, ref } }) => (
            <BorderedInput
              id="timeline-name"
              containerClassName={'w-[300px] mb-6'}
              placeholder="Timeline name"
              inputSize="full-width"
              type="text"
              inputLabel={'Timeline name'}
              required={true}
              value={value}
              onChange={e => {
                onChange(e.target.value);
              }}
            />
          )}
        />
        <Controller
          control={control}
          name={'timelineDescription'}
          rules={{ required: true }}
          render={({ field: { onChange, value, ref } }) => (
            <BorderedInput
              id="timeline-description"
              containerClassName={'w-[300px] mb-6'}
              placeholder="Timeline description"
              inputSize="full-width"
              type="text"
              inputLabel={'Timeline description'}
              required={true}
              value={value}
              onChange={e => {
                onChange(e.target.value);
              }}
            />
          )}
        />
        <Controller
          control={control}
          name={'productCodes'}
          rules={{ required: true }}
          render={({ field: { onChange, value, ref } }) => (
            <BorderedInput
              id="product-code"
              containerClassName={'w-[300px] mb-6'}
              placeholder="Product codes"
              inputSize="full-width"
              type="text"
              inputLabel={'Product code'}
              required={true}
              value={value}
              onChange={e => {
                onChange(e.target.value);
              }}
            />
          )}
        />
        <div className="mb-2 flex">
          <Typography variant="p2" color="var(--navi-color-gray-c2)">
            {'Anchor Date'}
          </Typography>
          <RequiredIcon />
        </div>
        <Controller
          control={control}
          name={'anchorDate'}
          rules={{ required: true }}
          render={({ field: { onChange } }) => (
            <Dropdown
              placeholder={'Anchor date'}
              placeholderColor={'var(--navi-color-gray-c3)'}
              showSolidArrow={true}
              arrowIconWidth={9}
              options={anchorDateOptions}
              onSelectionChange={e => {
                onChange(e.value);
              }}
              defaultSelected={{ label: 'FIRST UNPAID DUE DATE', value: 'FIRST_UNPAID_DUE_DATE' }}
              containerClasses={'w-[300px]'}
              pickerContainerClasses={'max-h-[300px] w-[300px]'}
              showTextCursorOnDisabled={true}
              tabIndexEnabled={true}
            />
          )}
        />
      </form>
    </Drawer>
  );
};

export default CreateTimelineDrawer;
